// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Css = require("../particle/Particle_Css.bs.js");
var Atom_Image_Ds = require("./Atom_Image_Ds.bs.js");
var Particle_Color = require("../particle/Particle_Color.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Screen_Css = require("../particle/Particle_Screen_Css.bs.js");
var Particle_Gradient_Ds = require("../particle/Particle_Gradient_Ds.bs.js");
var Particle_Gradient_Css = require("../particle/Particle_Gradient_Css.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Background_Css = require("../particle/Particle_Background_Css.bs.js");

function getPresentationRules(presentation) {
  return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Belt_Option.getWithDefault(Belt_Option.map(Particle_Css.imagePresentation(presentation), (function (rule) {
                        return [rule];
                      })), []));
}

function getSizeRules(size) {
  var rules = Particle_Screen_Css.toRules(undefined, undefined, Particle_Css.imageSize, size);
  return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, rules);
}

function makeBackgroundRules(background, imagePlaceholderFeatureFlipping) {
  var background$1 = background !== undefined ? Caml_option.some(Caml_option.valFromOption(background)) : (
      imagePlaceholderFeatureFlipping ? undefined : Caml_option.some(Particle_Background_Ds.imagePlaceholder)
    );
  return Belt_Option.mapWithDefault(background$1, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []), (function (background) {
                return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Background_Css.toCss(background));
              }));
}

function getColorRules(color) {
  if (color !== undefined) {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.color(Particle_Color.Css.color(color))]);
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
  }
}

function makeImageRules(size, presentation, background, imagePlaceholderFeatureFlipping, color) {
  var colorRules = getColorRules(color);
  var presentationRules = getPresentationRules(presentation);
  var sizeRules = getSizeRules(size);
  var backgroundRules = makeBackgroundRules(background, imagePlaceholderFeatureFlipping);
  return Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concat(presentationRules, sizeRules), backgroundRules), colorRules);
}

function toCss(imagePlaceholderFeatureFlippingOpt, imageKind) {
  var imagePlaceholderFeatureFlipping = imagePlaceholderFeatureFlippingOpt !== undefined ? imagePlaceholderFeatureFlippingOpt : /* Off */1;
  var match = Atom_Image_Ds.view(imageKind);
  var gradient = match.gradient;
  var color = match.color;
  var background = match.background;
  if (gradient === undefined) {
    return {
            image: makeImageRules(match.size, match.presentation, background, imagePlaceholderFeatureFlipping, color),
            gradient: undefined
          };
  }
  var gradientRules = Particle_Gradient_Css.toCss(Particle_Gradient_Ds.view(gradient));
  return {
          image: makeImageRules(match.size, match.presentation, background, imagePlaceholderFeatureFlipping, color),
          gradient: Caml_option.some(gradientRules)
        };
}

exports.getPresentationRules = getPresentationRules;
exports.getSizeRules = getSizeRules;
exports.makeBackgroundRules = makeBackgroundRules;
exports.getColorRules = getColorRules;
exports.makeImageRules = makeImageRules;
exports.toCss = toCss;
/* CssJs Not a pure module */
